import axios from "axios";

export const getUserDetails = (params:any) => {
  return axios
    .get('https://urlrecat.auth.us-east-1.amazoncognito.com/oauth2/userInfo', {
      headers: {
        Authorization: 'Bearer ' + params.access_token,
      },
    })
    .then((response) => {
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }
      return response.data;
    });
};

export const logout = () => {
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);

  return null;
};
